import React from "react";
import PublicLegalPage from "./PublicLegalPage";

export default function PublicSicherungsabtretung() {
  return (
    <PublicLegalPage
      title="Separate Sicherungsabtretung von Gutachtenhonoraren"
      subtitle="Diese Vereinbarung sollte zusätzlich unterschrieben werden."
      lastUpdated="13. Juni 2026"
      testid="page-public-sicherungsabtretung"
    >
      <h2>§ 1 Sicherungszweck</h2>
      <p>
        Zur Sicherung sämtlicher gegenwärtiger und zukünftiger Forderungen der{" "}
        <strong>EasyGutachter Software GmbH</strong> aus dem Software-, Lizenz- und Nutzungsvertrag tritt
        der Nutzer sämtliche gegenwärtigen und zukünftigen Vergütungsansprüche aus Kfz-Gutachten,
        Fahrzeugbewertungen, Schadengutachten und sonstigen sachverständigen Leistungen an die
        EasyGutachter Software GmbH ab.
      </p>

      <h2>§ 2 Annahme</h2>
      <p>
        Die EasyGutachter Software GmbH nimmt die Abtretung an.
      </p>

      <h2>§ 3 Einziehungsbefugnis</h2>
      <p>
        Der Nutzer bleibt bis auf Widerruf berechtigt, die abgetretenen Forderungen selbst einzuziehen.
      </p>

      <h2>§ 4 Widerruf bei Zahlungsverzug</h2>
      <p>
        Gerät der Nutzer mit einer Zahlung aus dem Vertragsverhältnis länger als 14 Tage in Verzug,
        kann EasyGutachter die Einziehungsbefugnis widerrufen.
      </p>

      <h2>§ 5 Offenlegung und Direkteinzug</h2>
      <p>
        Nach Widerruf darf EasyGutachter die Abtretung gegenüber Versicherungen, Auftraggebern,
        Rechtsanwälten und sonstigen Zahlungspflichtigen offenlegen und die Forderungen unmittelbar
        einziehen.
      </p>

      <h2>§ 6 Verwertung der Sicherung</h2>
      <p>
        EasyGutachter darf die eingezogenen Beträge zur Begleichung aller offenen Forderungen aus dem
        Vertragsverhältnis verwenden, einschließlich Lizenzgebühren, Mahnkosten, Inkasso- und
        Rechtsanwaltskosten.
      </p>

      <h2>§ 7 Überschüsse</h2>
      <p>
        Übersteigen eingezogene Beträge die offenen Forderungen von EasyGutachter, wird der
        überschießende Betrag an den Nutzer ausgekehrt.
      </p>

      <h2>§ 8 Zustimmung</h2>
      <p>
        Der Nutzer bestätigt, dass die Sicherungsabtretung ausdrücklich vereinbart wurde und ihm deren
        rechtliche Folgen bekannt sind.
      </p>

      <h2>§ 9 Dauer</h2>
      <p>
        Die Sicherungsabtretung bleibt bis zur vollständigen Begleichung aller Forderungen aus der
        Geschäftsbeziehung bestehen.
      </p>

      <h2>Ergänzende Datenschutzhinweise</h2>
      <p>
        Im Zusammenhang mit der Forderungseinziehung gelten unsere{" "}
        <a href="/legal/datenschutz">vollständigen Datenschutzhinweise</a> nach DSGVO.
      </p>

      <p className="text-sm text-zinc-500 mt-10">
        Bei Rückfragen:{" "}
        <a href="mailto:info@easy-gutachter.de">info@easy-gutachter.de</a>
      </p>
    </PublicLegalPage>
  );
}
